import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-left">
        <span className="footer-text">© 2025 CAPS+. All rights reserved.</span>
      </div>
      <div className="footer-right">
        <span className="footer-text">Version 2.1.0</span>
        <span className="footer-separator">|</span>
        <span className="footer-text">Status: Online</span>
      </div>
    </footer>
  );
};

export default Footer;